import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import electronSelector from './electronSelector';

const ElectronVisible = ({ children, isElectron }) => (isElectron ? children : null);

ElectronVisible.propTypes = {
    isElectron: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(electronSelector)(ElectronVisible);
